import { cacheMarketingParams } from './query-params.js';
import { applyHomepageMarketingParams } from './homepage.js';
import { initializeSubmissionButtonParams } from './submission-links.js';

function getReviewCount() {
  const reviewElement = document.querySelector('.jdgm-all-reviews-text__text[data-number-of-reviews]');
  if (!reviewElement) {
    return null;
  }

  const rawCount = reviewElement.getAttribute('data-number-of-reviews') || '';
  const parsedCount = parseInt(rawCount.replace(/[^\d]/g, ''), 10);
  return Number.isFinite(parsedCount) ? parsedCount : null;
}

function formatRoundedCount(reviewCount) {
  const roundedToNearestThousand = Math.round(reviewCount / 1000) * 1000;
  return `${new Intl.NumberFormat('en-US').format(roundedToNearestThousand)}+`;
}

function updateHappyCustomersText() {
  const reviewCount = getReviewCount();
  if (!reviewCount) {
    return false;
  }

  const formattedCount = formatRoundedCount(reviewCount);
  let updated = false;
  const textElements = document.querySelectorAll('gp-product div[data-gp-text] p');

  textElements.forEach((element) => {
    const currentText = element.textContent || '';

    if (!/happy customers/i.test(currentText)) {
      return;
    }

    const replacedText = currentText.replace(/[\d,]+(?:\+)?(?=\s*Happy Customers)/i, formattedCount);
    if (replacedText !== currentText) {
      element.textContent = replacedText;
      updated = true;
    }
  });

  return updated;
}

function syncHappyCustomersWithReviews() {
  updateHappyCustomersText();
}

function initializeMarketingScripts() {
  cacheMarketingParams();
  initializeSubmissionButtonParams();

  const runHomepageUpdates = () => {
    if (window.location.pathname === '/') {
      applyHomepageMarketingParams();
    }
  };

  const runSharedPageUpdates = () => {
    syncHappyCustomersWithReviews();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runHomepageUpdates);
    document.addEventListener('DOMContentLoaded', runSharedPageUpdates);
  } else {
    runHomepageUpdates();
    runSharedPageUpdates();
  }
}

if (typeof window !== 'undefined') {
  initializeMarketingScripts();
}
